import script from "./ConsumerSearchView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerSearchView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerSearchView.vue?vue&type=style&index=0&id=3d9719de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9719de"]])

export default __exports__